import React, { useState, useContext } from "react";
import "./Login.scss";
import FathomLogo from "../../../assets/image/logo/Fathom-Logo.png";
import { Button, Input, Modal } from "antd";
import { App } from "antd";
import "antd/dist/reset.css";
import { useNavigate, Link } from "react-router-dom";
import {
  LockOutlined,
  MailOutlined,
  // GoogleOutlined
} from "@ant-design/icons";
import {
  sendPasswordResetEmail,
  // GoogleAuthProvider,signInWithPopup,deleteUser
} from "firebase/auth";
import { auth, signInWithEmailAndPassword } from "../firebase-config";
import { AppContext } from "../../../context/Context";
import { URL } from "../../../constant/url";
import axios from "axios";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { setIsAuthenticated } = useContext(AppContext);
  const { message } = App.useApp();

  const handleLogin = async () => {
    if (!email || !password) {
      message.error("Please input both email and password!");
      return;
    }
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );

      const user = userCredential.user;
      message.success("Login successful!");
      setIsAuthenticated(true);
      navigate("/menupage", { replace: true });
      const idTokenResult = await user.getIdTokenResult();
      const expirationTime = idTokenResult.claims.exp - 60 * 59;
      localStorage.setItem("lastLoginTime", expirationTime);
    } catch (error) {
      message.error("Invalid credentials. Try again.");
    }
  };

  const handleForgotPassword = async () => {
    try {
      const response = await axios.post(
        `${URL}/api/user/isexists`,
        {
          email: resetEmail,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        // message.success(response.data.message);
        await sendPasswordResetEmail(auth, resetEmail);
        message.success(
          "Password reset email has been sent. Please check your inbox!"
        );
        setIsModalVisible(false);
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.data.message === "User does not exist") {
          message.error(
            "The user does not exist. Please proceed with registration."
          );
        } else {
          message.error("Please input a correctly formatted email address.");
        }
        console.log(error.response.data.message);
      } else {
        message.error(
          "Network error. Please check your connection and try again."
        );
      }
    }
  };

  return (
    <div className="main_frame_login">
      <div className="parent_frame_element_login">
        <div className="frame_elements_login">
          <div className="frame_logo_login">
            <img src={FathomLogo} alt="fathomlogo" />
          </div>
          <div>
            <div className="frame_title_signin">
              <span>Sign In</span>
            </div>
            <div className="frame_sub_title">
              <span>Welcome to Dashboard!</span>
            </div>
          </div>
          <div className="fram_item_login_form">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="frame_input">
                <div className="element_input_label_email">
                  <label htmlFor="email">Email</label>
                  <Input
                    id="email"
                    prefix={<MailOutlined />}
                    placeholder="Enter Your Email"
                    className="input_field"
                    style={{ borderColor: "gray", boxShadow: "unset" }}
                    type="email"
                    onChange={(event) => {
                      setEmail(event.target.value);
                    }}
                  />
                </div>

                <div className="element_input_label_password">
                  <label htmlFor="password">Password</label>
                  <Input.Password
                    id="password"
                    prefix={<LockOutlined />}
                    placeholder="Enter Your Password"
                    className="input_field"
                    style={{ borderColor: "gray", boxShadow: "unset" }}
                    onChange={(event) => {
                      setPassword(event.target.value);
                    }}
                  />
                </div>
                <div className="frame_forgot_password">
                  <Link
                    onClick={() => setIsModalVisible(true)}
                    className="forgot-password"
                  >
                    <span>Forgot your password?</span>
                  </Link>
                </div>
              </div>
              <div className="frame_button_login">
                <Button
                  block
                  htmlType="submit"
                  className="color_button"
                  onClick={handleLogin}
                >
                  Sign in
                </Button>
              </div>

              {/* <div className="frame_button_login">
                <Button
                  block
                  htmlType="submit"
                  className="color_button"
                  onClick={googleLogin}
                >
                  Continue With Google <GoogleOutlined />
                </Button>
              </div> */}
            </form>

            {/* <div className="frame_create_account">
              <span className="text">Don't have an account?</span>{" "}
              <Link to="/register" className="frame_sign_up">
                <span>Sign up now</span>
              </Link>
            </div> */}
          </div>
        </div>
      </div>
      <Modal
        title="Reset Password"
        open={isModalVisible}
        onOk={async () => {
          await handleForgotPassword();
          setResetEmail("");
        }}
        onCancel={() => {
          setIsModalVisible(false);
          setResetEmail("");
        }}
        okButtonProps={{
          style: { backgroundColor: "red", borderColor: "red" },
        }}
        className="frame_modal_login"
      >
        <Input
          placeholder="Enter your email"
          onChange={(event) => setResetEmail(event.target.value)}
          value={resetEmail}
        />
      </Modal>
    </div>
  );
};

export default Login;
